export class Perfil{

    static readonly GESTAO_TALONARIO ="Gestão Talonário";
    static readonly UNIDADE_TALONARIO ="Unidade Talonário";
    static readonly POLICIAL_TALONARIO ="Policiais Talonário";
    
}